export const isAccountRoute = (pathname: string): boolean =>
  pathname.split('/').includes('account')
